import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJConfirmModal from "../../../common/component/modal/FJConfirmModal";
import {FJModalAction} from '../../../redux/action/FJRoot.action'
import FJCommonModal from "../../../common/component/modal/FJCommonModal";
import FJMediaAction from "../../../redux/action/FJMedia.action";

class FJConfirmModalContainer extends Component {

  _onCancel = () => {
    this.props.hideConfirmModal();
  };

  _onSubmit = () => {
    this.props.hideConfirmModal();
  };

  _onHidden = () => {
    this.props.initConfirmModalData();
  };

  render() {
    let {
      visible,
      cancelText,
      submitText,
      cancelType,
      submitDanger,
      headerText,
      bodyText,
      onCancel,
      onSubmit,
      hasCancel,
      isDistinguishCancel,
      onClickOther,
      updateDragFileModeStateAction,
      hasNoShowAgain
    } = this.props;
    return (
      <FJCommonModal visible={visible}
                     zIndex={1001}
                     width='630px'
                     onHidden={this._onHidden}
                     updateDragFileModeStateAction={updateDragFileModeStateAction}
      >
        <FJConfirmModal visible={visible}
                        headerText={headerText}
                        bodyText={bodyText}
                        cancelText={cancelText}
                        submitText={submitText}
                        cancelType={cancelType}
                        submitDanger={submitDanger}
                        hasCancel={hasCancel}
                        isDistinguishCancel={isDistinguishCancel}
                        onCancel={(type) => {
                          onCancel ? onCancel(this._onCancel, type) : this._onCancel();
                        }}
                        onSubmit={(isNoShow) => {
                          onSubmit ? onSubmit(this._onSubmit, isNoShow) : this._onSubmit();
                        }}
                        onClickOther={() => {
                          onClickOther ? onClickOther(this._onCancel) : this._onCancel();
                        }}
                        hasNoShowAgain={hasNoShowAgain}
        />
      </FJCommonModal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.modal.isShowModalConfirm,
    headerText: state.modal.headerText,
    bodyText: state.modal.bodyText,
    onCancel: state.modal.onCancel,
    onSubmit: state.modal.onSubmit,
    cancelText: state.modal.cancelText,
    submitText: state.modal.submitText,
    cancelType: state.modal.cancelType,
    submitDanger: state.modal.submitDanger,
    hasCancel: state.modal.hasCancel,
    isDistinguishCancel: state.modal.isDistinguishCancel,
    onClickOther: state.modal.onClickOther,
    hasNoShowAgain: state.modal.hasNoShowAgain
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    hideConfirmModal: function () {
      dispatch(FJModalAction.hideConfirmModalAction());
    },
    initConfirmModalData: function () {
      dispatch(FJModalAction.initConfirmModalDataAction());
    },
    updateDragFileModeStateAction: function (visible) {
      dispatch(FJMediaAction.updateDragFileModeStateAction(visible))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJConfirmModalContainer);
